export default __webpack_public_path__ + "static/media/borda-direita-verso.272f9bc1.png";